import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=42cda0fe&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42cda0fe')) {
      api.createRecord('42cda0fe', component.options)
    } else {
      api.reload('42cda0fe', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=42cda0fe&", function () {
      api.rerender('42cda0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NbHHp5A2ZRL/JS/comp/ErrorMessage.vue"
export default component.exports